import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M17 5a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M3 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M17 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-3"}],["path",{"d":"M5 7l0 10","key":"svg-4"}],["path",{"d":"M7 5l10 0","key":"svg-5"}],["path",{"d":"M7 19l10 0","key":"svg-6"}],["path",{"d":"M19 7l0 10","key":"svg-7"}]]

const IconShape = createReactComponent('outline', 'shape', 'Shape', __iconNode);

export default IconShape;